<script>
		import {change_attribute} from "../client.svelte.js";

		let plot = $derived(view.section?.plot ?? "")
</script>

<!-------------------------------- HTML -------------------------------------->

<div class="plotPanel">
	<div id='plotBox'>
		<h2>Handlung</h2>
		<textarea id='plot' onchange={change_attribute.bind(section)}>{plot}</textarea>
	</div>

</div>


<!-------------------------------- HTML -------------------------------------->

<style lang="sass">
	@use "../colors" as colors

	#plot
		width: 100%
		height: calc(100vh - var(--menu-height) - 78px)
		resize: none

</style>